import React, { Component } from 'react';
import styled from 'styled-components';
import debounce from 'lodash.debounce';
import parse from 'html-react-parser';

import Container from 'partials/Container';
import GridElement from 'partials/GridElement';

import Media, { ScreenWidth } from 'css/Media';

class Tables extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
        }
    }

    componentWillMount() {
        this.checkScreenSize();
    }

    componentDidMount() {
        window.addEventListener('resize', debounce(() => this.checkScreenSize()),500);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.checkScreenSize);
    }

    checkScreenSize() {
        let isMobile = true;

        if(ScreenWidth.greaterThan('s')) {
            isMobile = false;
        }
        this.setState({isMobile: isMobile});
    }

    convertPhonenumbersToHyperlinks = (content) => {
        if (!content) return;
        var urlRegex = /(\+\d{1,3}\s?)?((\(\d{3}\)\s?)|(\d{2})(\s|-?))(\d{2}(\s|-?))(\d{2}(\s|-?))(\d{2})(\s?(([E|e]xt[:|.|]?)|x|X)(\s?\d+))?/;
        return content.replace(urlRegex, function (phonenumber) {
            return (
                '<a href="tel:' +
                phonenumber +
                '">' +
                phonenumber +
                '</a>'
            );
        });
    }

    render() {
        const { isMobile } = this.state;
        const { data, last } = this.props;

        return (
            <ModuleWrapper last={last}>
                <Container grid bleedRight={isMobile}>
                    <GridElement
                        colStart={{default: 1, s: 7}}
                        colEnd={{default: 8, s: 18}}
                    >
                        { data.title && <h2>{data.title}</h2> }
                        <ul>
                            { data.table_rows.map((row, idx) => {
                                return (
                                    <StyledRow key={idx}>
                                        <p>{this.convertPhonenumbersToHyperlinks(row.col_1)}</p>
                                        { row.col_2 && <p>{parse(this.convertPhonenumbersToHyperlinks(row.col_2))}</p> }
                                        { row.col_3 && <p>{parse(this.convertPhonenumbersToHyperlinks(row.col_3))}</p> }
                                        { row.col_4 && <p>{parse(this.convertPhonenumbersToHyperlinks(row.col_4))}</p> }
                                    </StyledRow>
                                )
                            })}
                        </ul>
                    </GridElement>
                </Container>
            </ModuleWrapper>
        );
    }
}

export default Tables;

const ModuleWrapper = styled.section`
    margin: ${props => props.last ? `${props.theme.spacing.elementM} 0 0` : `${props.theme.spacing.elementM} 0`};

    ${Media.greaterThan('s')`
        margin: ${props => props.last? `${props.theme.spacing.blockXS} 0 0` : `${props.theme.spacing.blockXS} 0`};
    `}

    .container {

        h2 {
            ${props => props.theme.fonts.p};
            padding-bottom: ${props => props.theme.spacing.elementXS};
            font-weight: 600;

            ${Media.greaterThan('s')`
                padding-bottom: ${props => props.theme.spacing.elementS};
            `}
        }

        ${Media.lessThan('s')`
            padding-bottom: ${props => props.theme.spacing.contentXL};
        `}

        ul {
            ${Media.lessThan('s')`
                overflow-x: scroll;
            `}
        }
    }
`

const StyledRow = styled.li`
    padding-bottom: ${props => props.theme.spacing.contentM};
    margin-bottom: ${props => props.theme.spacing.contentM};
    border-bottom: 1px solid ${props => props.theme.colors.lines};
    display: grid;
    grid-template-columns: repeat(3, 1fr ${props => props.theme.spacing.blockXS}) 1fr;
    grid-template-areas: "first first_gap second second_gap third third_gap fourth";
    justify-content: start;

    p {
        
        &:nth-child(1) {
            grid-area: auto / first / auto / first_gap;
        }

        &:nth-child(2) {
            grid-area: auto / second / auto / second_gap;
        }

        &:nth-child(3) {
            grid-area: auto / third / auto / third_gap;
        }

        &:nth-child(4) {
            grid-area: fourth;
        }
    }


    ${Media.lessThan('s')`
        grid-template-columns: repeat(3, minmax(60px, 1fr) ${props => props.theme.spacing.blockXS}) 1fr;
    `}
`